/**
 * @file NotFoundPage.js
 * @module src/js/pages/NotFoundPage
 * @description
 * **Page component for handling 404 Not Found errors.**
 * - Displays a user-friendly message when a requested page does not exist.
 * - Encourages users to report the issue if they believe it's a mistake.
 * - Provides a link to return to the homepage.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import ThemeToggledWrapper from "../components/ThemeToggledWrapper";
import { Link } from "react-router-dom";
import ReportAnIssue from "../components/ReportAnIssue";

export default function NotFoundPage() {
    return (
        <ThemeToggledWrapper id="not-found" lightStyle={5} darkStyle={4}>
            <div className="inner">
                <header className="major special">
                    <h2>Not Found</h2>
                </header>
                <center>
                    <p>This page does not exist.</p>
                    <p>Please <ReportAnIssue>report an issue</ReportAnIssue> if you think this is a mistake.</p>
                    <p>We will try to fix it!</p>
                    <p>Thank you very much!</p>
                </center>
                <ul className="actions special" style={{ marginTop: "2em" }}>
                    <li><Link to="/" className="button">Back to Homepage</Link></li>
                </ul>
            </div>
        </ThemeToggledWrapper>
    );
}
